import { render } from "./Advices.vue?vue&type=template&id=24a90820"
import script from "./Advices.vue?vue&type=script&lang=js"
export * from "./Advices.vue?vue&type=script&lang=js"

import "./Advices.vue?vue&type=style&index=0&id=24a90820&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__